import React from 'react';
import PropTypes from 'prop-types';
import styles from 'routes/adminMobile/components/AdminMobileSaleStatusList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import { mainBgColor, mainPadd, mainPadd2, pageCommonGap1, pageEH2FontSize } from '../constraints/AdminConst';
import favStar from 'routes/adminMobile/images/favStar.png';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';

const AdminMobileSaleStatusList = ({ saleList, toggleFavorite }) => {
    if (!saleList || saleList.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {/* 반복 구간 */}
            {saleList && saleList.map((sale, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={10}>
                            <FlexChild alignItems="flex-start">
                                <HorizontalFlex>
                                    <FlexChild width="auto" padding="0 1rem 0 0">
                                        <P size={pageEH2FontSize}>{sale.storeName}</P>
                                    </FlexChild>
                                    <FlexChild>
                                        {/* 즐겨찾기 버튼 */}
                                        <div
                                            className={`${styles.favBtn} ${sale.storeFav ? styles.favorite : ''}`}
                                            onClick={() => toggleFavorite(index)}
                                        >
                                            <img className={styles.favIcon} src={favStar} alt='즐겨찾기 아이콘' />
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={pageEH2FontSize}>총 판매량</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end">
                                        <P size={pageEH2FontSize}>
                                            {sale.storeAllSaleVol ? sale.storeAllSaleVol.toLocaleString() : 0}개
                                        </P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={pageEH2FontSize}>총 매출액</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end">
                                        <P size={pageEH2FontSize}>
                                            {sale.storeAllSales ? sale.storeAllSales.toLocaleString() : 0}원
                                        </P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
            {/* 반복 구간 */}
        </VerticalFlex>
    );
};

// Props의 타입 검사
AdminMobileSaleStatusList.propTypes = {
    saleList: PropTypes.arrayOf(PropTypes.shape({
        storeName: PropTypes.string.isRequired,
        storeAllSaleVol: PropTypes.number.isRequired,
        storeAllSales: PropTypes.number.isRequired,
        storeFav: PropTypes.bool.isRequired // 추가: 즐겨찾기 여부
    })).isRequired
};

export default AdminMobileSaleStatusList;